import React from 'react';
import { pricing } from '@anonymizePro/mock/contents';
import PricingCard from '@anonymizePro/components/cards/pricing-card';

function Pricing() {
    return (
        <div className="mt-[100px] flex flex-col items-center px-10 text-center lg:mt-[273px] lg:px-[128px]">
            <p className="anonymize-h2 text-black-800">{pricing.title}</p>
            <p className="anonymize-p4 mb-16 mt-4 max-w-[365px] text-black-700">{pricing.description}</p>
            <div className="pricingShadow grid grid-flow-row grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {pricing.types.map((type) => {
                    return <PricingCard key={type.title} pricing={type} />;
                })}
            </div>
        </div>
    );
}

export default Pricing;
